<div *ngIf="onlineStatus === 'online'" class="online alert alert-success">
    <span>{{onlineStatusMessage}}</span>
  </div>
  
  <div *ngIf="onlineStatus === 'offline'" class="offline alert alert-danger">
    <span>{{onlineStatusMessage}}</span>
  </div>
  
 